import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { StatusCode } from "api/protocols";
import Page from "components/page/Page";
import DataTable from "components/dataTable/DataTable";
import Card from "components/card/Card";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil, faPlus } from "@fortawesome/pro-regular-svg-icons";
import "./buildings.scss";
import { useAppDispatch } from "hooks/redux";
import { showError } from "redux/actions/ui";
import { GetAccommodationBuildings } from "api/rpc/2024-04/facilityAdmin/accommodation/building";

export interface IAccommodationBuilding {
  id: number;
  title: string;
  code: string;
  description: string;
}

export function Buildings() {
  const history = useHistory();
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const [accommodationBuildings, setAccommodationBuildings] = useState(undefined);

  const [filterState, setFilterState] = useState({
    search: "",
    offset: 0,
    limit: 10,
  });

  useEffect(() => {
    void loadAccommodationBuildings();
  }, [filterState]);

  async function loadAccommodationBuildings() {
    if (accommodationBuildings !== undefined) {
      setAccommodationBuildings(undefined);
    }
    const accommodationBuildingsRes = await GetAccommodationBuildings(null, false);

    if (accommodationBuildingsRes.status !== StatusCode.OK) {
      dispatch(showError("Error loading locations"));

      setAccommodationBuildings([]);
      return;
    }

    setAccommodationBuildings(accommodationBuildingsRes.data);
  }

  return (
    <Page className="mt-4">
      <Card
        title="Buildings & Locations"
        subtitle="Manage your buildings and locations here"
        titleActions={[
          {
            action: () => history.push("/admin/accommodation/buildings/new"),
            content: (
              <>
                <FontAwesomeIcon icon={faPlus} style={{ marginRight: "6px" }} />
                {t("New location")}
              </>
            ),
            buttonType: "primary",
          },
        ]}
      >
        <div style={{ marginTop: "24px" }}>
          <DataTable
            noRoundedTop
            columns={[
              { label: t("Title"), width: "30%" },
              { label: t("Code"), width: "30%" },
              { label: t("Description"), width: "30%" },
              { label: "", width: "10%" },
            ]}
            loading={accommodationBuildings === undefined}
            footer={{
              tableLimit: filterState?.limit,
              tableOffset: filterState?.offset,
              handleTableOffset: direction =>
                setFilterState(prev => ({
                  ...prev,
                  offset: direction === "prev" ? prev.offset - prev.limit : prev.offset + prev.limit,
                })),
              disableNextOffset: !accommodationBuildings || !(accommodationBuildings?.length === filterState?.limit),
            }}
          >
            {accommodationBuildings?.map((building: IAccommodationBuilding, index: number) => {
              return (
                <tr
                  key={index}
                  onClick={() => history.push("/admin/accommodation/buildings/" + String(building.id))}
                  className="clickable"
                >
                  <td>{building?.title}</td>
                  <td>{building?.code}</td>
                  <td>{building?.description}</td>
                  <td className="text-right">
                    <FontAwesomeIcon icon={faPencil} />
                  </td>
                </tr>
              );
            })}
          </DataTable>
        </div>
      </Card>
    </Page>
  );
}
